import useChatSend from "../hooks/useChatSend";
import { useMemo } from "react";
import { ChatServerResponse } from "@/custolink-views/asset_frontend/asset_view/asset_components/ai_support/components/ChatView";
import { useTranslation } from "react-i18next";

/**
 * The chat's empty state: a short welcome line, and - only if the component
 * actually has suggested prompts to offer (the two server-translated
 * `aiprompt.*` strings) - tappable chips for them. No suggestions are
 * invented here; without them the welcome's own second line already reads as
 * the one-line prompt hint.
 */
const ChatLandingView = (p: {
  chatPrompt: (query: string) => Promise<ChatServerResponse>;
  handleSendOverride?: (prompt: string) => Promise<void>;
}) => {
  const { handleSend: handleSendDefault } = useChatSend(p.chatPrompt);
  const handleSend = p.handleSendOverride ?? handleSendDefault;
  const { t } = useTranslation();

  const promptSuggestion: { title: string; prompt: string }[] = useMemo(
    () => [
      {
        title: t("component.aisupport.aiprompt.manualAssistance"),
        prompt: t("component.aisupport.aiprompt.manualAssistance"),
      },
      {
        title: t('component.aisupport.aiprompt.specificationAssistance'),
        prompt: t('component.aisupport.aiprompt.specificationAssistance'),
      },
    ],
    [t],
  );

  return (
    <div className="mx-auto w-full max-w-[560px] px-4 pt-4">
      <h2 className="text-lg font-semibold leading-snug tracking-[-0.01em] text-[var(--rda-on-surface)]">
        {t("component.aisupport.header.hello")}
      </h2>
      <p className="mt-0.5 text-sm text-[var(--rda-muted)]">
        {t('component.aisupport.header.howToHelp')}
      </p>

      {promptSuggestion.length > 0 && (
        <div className="mt-4 flex flex-wrap gap-2">
          {promptSuggestion.map((suggestion) => (
            <button
              key={suggestion.title}
              type="button"
              className="rda-tile rounded-full border border-[color:var(--rda-line)] bg-[var(--rda-surface)] px-3.5 py-2 text-left text-sm font-medium text-[var(--rda-on-surface)] transition-colors hover:border-[color:var(--rda-accent-text)] hover:text-[var(--rda-accent-text)]"
              onClick={() => handleSend(suggestion.prompt)}
            >
              {suggestion.title}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChatLandingView;
